import React, { FC, useCallback, useEffect, useState } from "react";
import { ITextProps } from "@/common/Text//Text.types";
import * as Styled from "@/common/Text//Text.styles";

const Text: FC<ITextProps> = (props) => {
  const { fontSize, align, fontFamily, onClick, textDecoration, color, margin, padding, responsive = true, cursor, role, className = '', id, children} =
    props;

  const [isElement, setIsElement] = useState<boolean>(typeof(children) != 'string' && !!children);

  useEffect(() => {
    if(typeof(children) != 'string' && !!children) setIsElement(true);
  }, [children])

 const getInnerHtml = useCallback(() => {
  if(!isElement) {
    return {
      dangerouslySetInnerHTML:{
        __html:children as string
      }
    }
  }
}, [children, isElement])

  return (
    <Styled.Text
      onClick={(event) => onClick && onClick(event)}
      fontFamily={fontFamily}
      fontSize={fontSize}
      align={align}
      textDecoration={textDecoration}
      color={color}
      margin={margin}
      padding={padding}
      responsive={responsive}
      cursor={cursor}
      role={role}
      className={className}
      id={id}
      {...getInnerHtml()}
    >
      {isElement ? children : null}
    </Styled.Text>
  );
};

export default Text;
